import { Desktop } from './components/desktop';
import { Mobile } from './components/mobile';

export const Adaptive = {
	Desktop,
	Mobile,
};
